module.exports = __webpack_public_path__ + "static/media/gt.8aa539da.svg";